var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg11Leisure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3639 32.1864C22.4789 31.985 22.661 31.831 22.8759 31.7438C28.7327 29.367 32.863 23.6219 32.863 16.912C32.863 8.07546 25.6996 0.912018 16.863 0.912018C8.02648 0.912018 0.863037 8.07546 0.863037 16.912C0.863037 23.708 5.10009 29.5144 11.0767 31.8337C11.2979 31.9195 11.4859 32.0759 11.6036 32.282L15.2199 38.6106C15.9877 39.9542 17.9251 39.9542 18.6929 38.6106L22.3639 32.1864Z",
    fill: "#5746C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.863,
    cy: 16.912,
    r: 13.5,
    fill: "#291F50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84859 21.3441C7.68862 21.0775 7.88067 20.7383 8.19158 20.7383H25.5347C25.8457 20.7383 26.0377 21.0775 25.8777 21.3441L23.7191 24.9418C23.5384 25.243 23.2129 25.4273 22.8616 25.4273H10.8647C10.5135 25.4273 10.1879 25.243 10.0072 24.9418L7.84859 21.3441Z",
    fill: "#4841A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1121 20.7383H25.5348C25.8457 20.7383 26.0378 21.0775 25.8778 21.3441L24.3575 23.8777L16.5946 21.7758L13.1121 20.7383Z",
    fill: "#353071"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3943 7.20236C16.3943 6.94339 16.6042 6.73346 16.8632 6.73346V6.73346C17.1222 6.73346 17.3321 6.94339 17.3321 7.20236V20.8005H16.3943V7.20236Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8633 7.14011L24.0211 16.0874C24.1911 16.2999 24.104 16.6163 23.8492 16.7118L16.8633 19.3316V7.14011Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8633 7.60901L22.6917 16.1275C22.8315 16.3318 22.754 16.6128 22.5292 16.7165L16.8633 19.3316V7.60901Z",
    fill: "#8F87F3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3943 9.01572L12.3614 17.0816C12.2594 17.2855 12.3483 17.5334 12.5567 17.626L16.3943 19.3316V9.01572Z",
    fill: "#E7E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3943 9.01572L16.372 9.49472L15.9239 19.125L16.3943 19.3316V9.01572Z",
    fill: "#ABA9C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg11Leisure);
export default __webpack_public_path__ + "static/media/11_leisure.5ad1e0a6842b0d8f1ae084dbeddcc9f2.svg";
export { ForwardRef as ReactComponent };